import { PopoverTrigger } from '@chakra-ui/react'
import { FC } from 'react'

export const Trigger = PopoverTrigger as typeof PopoverTrigger &
  FC<{ children: any }>
